import React, { Suspense } from "react";
import { PropTypes } from "prop-types";
import reactWrapper from "@harbor/elements/utils/react/wrapper";

import _ from "lodash";

import BulletColumnAndLineChart from "../../../../../common/BulletColumnAndLineChart";
import Spinner from "../../../../../common/Spinner";

//utils
import { getTipBulletColumnChart } from "../../../../../utils/common";
import { EXPORT_CSV_LABELS } from "../../../../../utils/enums";
// lazy loading components
const NoDataAvailable = React.lazy(() =>
  import("../../../../../common/NoDataAvailable")
);
const ErrorComponent = React.lazy(() =>
  import("../../../../../common/ErrorComponent")
);

import useI18n from "../../../../../i18n/useI18n";

//style
import css from "../../../insightsAppMagneticStyle.less";

const [HbrCard] = reactWrapper(["hbr-card"]);

const PathQosUserExpChart = props => {
  const { tViews } = useI18n('views');
  const { selectedSite } = props.globalFilter;
  switch (true) {
    case props.hasFailed:
      return (
        <div
          className={css["qos-user-exp-chart"]}
          data-cy="pathQosUserExpChartError"
        >
          <Suspense fallback={<Spinner />}>
            <ErrorComponent
              {...props.errorMessage}
              width={"200px"}
              className={"super-small-dashlet-error"}
            />
          </Suspense>
        </div>
      );
    case props.userChartData &&
      props.userChartData.length === 0 &&
      props.isDone:
      return (
        <div
          className={css["qos-user-exp-chart"]}
          data-cy="pathQosUserExpChartNoData"
        >
          <div className="no-data-chart">
            <Suspense fallback={<Spinner />}>
              <NoDataAvailable
                text={
                  tViews('predictiveNetworks.networkQoeMetricChartNoData')
                }
              />
            </Suspense>
          </div>
        </div>
      );
    case props.isDone && !_.isEmpty(props.userChartData):
      return (
        <HbrCard
          className={css["qos-user-exp-chart"]}
          data-cy="pathQosUserExpChart"
        >
           <div className="hbr-type-h2">
             {tViews('appGroupPerSiteSidePanelTitle')} 
          </div>
          {
            <BulletColumnAndLineChart
              data={props.userChartData}
              chartsData={props.chartsData}
              callbackFromParent={props.callbackFromParent}
              showSynchronization={true}
              disabledScrollbar={false}
              chartName={EXPORT_CSV_LABELS.PN_PATH_RECOMMENDATIONS}
              chartAriaLabel={tViews('a11yLabels.pathRecommendations')}
              isZoomDisabled={false}
              chartProps={{
                site: selectedSite,
                isSeriesConnected: false,
                chartId: "sidePanelUserExpChart",
                useCompactScrollbarDateLabels: true,
                tooltipHTML: getTipBulletColumnChart(),
                zoomInDaysCount: 2,
                leftTitleForY:
                  tViews('appGroupPerSite.userExpChartActiveUsrLabel'),
                rightTitleForY: tViews('appGroupPerSite.meanQuality'),
                legendLabels: [
                  tViews('appGroupPerSite.userExpChartRecomLabel'),
                  tViews('appGroupPerSite.userExpChartCurrentPathLabel'),
                  tViews('appGroupPerSite.userExpChartActiveUsrLabel')
                ],
              }}
              isTitleShown={true}
              disableTitleOffset
              isScrollbarGripVisible={true}
            />
          }
        </HbrCard>
      );
    default:
      return (
        <div className="center-spinner">
          <Spinner />
        </div>
      );
  }
};

PathQosUserExpChart.propTypes = {
  chartProps: PropTypes.object.isRequired,
  callbackFromParent: PropTypes.func,
  chartsData: PropTypes.array.isRequired,
  userChartData: PropTypes.array,
  globalFilter: PropTypes.object,
  hasFailed: PropTypes.bool,
  isDone: PropTypes.bool,
  errorMessage: PropTypes.object
};

export default PathQosUserExpChart;
